import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Alert } from '@printdeal/ui-library';
import { useSegmentation, isCustomerProgramReseller } from '@printdeal/segmentation/react';
import ProgressBar from './ProgressBar';
import { convertToCents } from '../../helpers/segmentedCustomerHelper';
import { Money } from '../Money';

const CustomerProgramWidget = () => {
  const { data: segmentationData } = useSegmentation();
  if (!segmentationData) {
    return null;
  }

  const {
    isReseller, isPartOfCustomerProgram, traits: { revenue_365: revenue365 }, category,
  } = segmentationData;

  if (!isCustomerProgramReseller(isReseller, isPartOfCustomerProgram)) {
    return null;
  }

  const revenue365Value = (<Money value={convertToCents(revenue365 || 0)} />);

  return (
    <>
      <ProgressBar
        revenue365={revenue365}
        customersCategory={category}
      />
      <Alert variant="info" className="pd-my-9">
        <FormattedMessage
          id="account.dashboard.customerProgram.alert"
          defaultMessage="You spent {revenue365Value} last year, which puts you in our Partner Pro program {customersCategory}.
        As an introduction to the Partner Pro program, you can use our Premium model until December 4. On December 4, we will determine your Partner Pro status based on your turnover."
          values={{
            revenue365Value,
            customersCategory: category,
          }}
        />
      </Alert>
    </>
  );
};

export default CustomerProgramWidget;
